"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("../Box/Box"));

var _BrandSelectItem = _interopRequireDefault(require("./BrandSelectItem"));

var utils = _interopRequireWildcard(require("../../shared"));

var _useLocalStorageSVG = _interopRequireDefault(require("../../shared/hooks/useLocalStorageSVG"));

require("./BrandSelect.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
BrandSelect component
*/
function BrandSelect(_ref) {
  var children = _ref.children,
      className = _ref.className,
      title = _ref.title;
  var version = 1;
  (0, _useLocalStorageSVG["default"])({
    url: "https://screentone.djnews.tools/assets/brands-logos." + version + ".svg",
    id: 'st-brands-logos',
    version: version
  });
  var cssClasses = ['st_brandselect'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);

  var count = _react["default"].Children.count(children);

  var columns = 0;
  if (count === 0) return null;

  if (count <= 4) {
    columns = count;
  } else if (count <= 6) {
    columns = 3;
  } else {
    columns = 4;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cssClasses.join(' ')
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: "st_brandselect__box"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"].Title, null, title), /*#__PURE__*/_react["default"].createElement(_Box["default"].Content, {
    padding: {
      vertical: 'md',
      horizontal: 'mlg'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_brandselect__grid st_brandselect__grid--" + columns
  }, children))));
}

BrandSelect.propTypes = {
  /** title for Brand Select box */
  title: _propTypes["default"].string,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps
};
BrandSelect.defaultProps = {
  title: 'Select Brand',
  className: null
};
BrandSelect.Item = _BrandSelectItem["default"];
var _default = BrandSelect;
exports["default"] = _default;